import React from 'react';
import { Badge } from 'react-bootstrap';
import FacturasGlobalesTicketStatus from '../enum/FacturasGlobalesTicketStatus';

const FacturasGlobalesStatus = ({ item = {} }) => {
  let variant = 'light';

  let status = FacturasGlobalesTicketStatus.search(item.status);

  if (!status) {
    status = FacturasGlobalesTicketStatus.search(999);
  }

  if (status.isSuccess()) {
    variant = 'success';
  } else if (status.isDuplicate()) {
    variant = 'warning';
  } else if (status.isError() || status.isFailed() || status.isCancelled()) {
    variant = 'danger';
  } else if (status.isReplace()) {
    variant = 'info';
  }

  return <Badge variant={variant}>{status.getName()}</Badge>;
};

export default FacturasGlobalesStatus;
